import InvoiceDetailsContainer from "@legacy/invoices/InvoiceDetailsContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { INVOICES_ROUTES } from "@routes/invoices"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function InvoiceDetails() {
    const [listRoute] = useSlugExtractor([INVOICES_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const backDestination = hasPermission("invoices_list_permission", PERMISSION_LEVEL.FULL) ? listRoute : undefined

    return (
        <AppFrame.Root navigationType="inner">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle label="Invoice Details" backDestination={backDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <InvoiceDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
